angular.module('unica_event.event_controllers')

.controller('EventYearsController', function(
	$rootScope, $scope, $state,
	$confirm,
	EventListService
) {
	$scope.years = [];

	$scope.loadYears = function() {
		$scope.showLoader();
		$scope.canLoad = false;
		EventListService.years()
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.years = data;
				}
			});
	};

	$scope.loadYears();

})

;